import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    Status,
    StockTransferServiceProxy,
    StockTransferDto,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';

@Component({
    templateUrl: './stocktransfer.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class StockTransferComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';
   
    vendorDisplayPropertyFilter = '';
    status = Status;
    uploadUrl: string;

    constructor(
        injector: Injector,
        private _stockTransferServiceProxy: StockTransferServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/purchaseInvoices/ImportFromExcel';
    }

    getStockTransfer(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }
       
        this.primengTableHelper.showLoadingIndicator();

        this._stockTransferServiceProxy
            .getAll(
                this.filterText,
                this.appSession.user.locationId,
                null,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }
    print(id: number): void {
            window.open(AppConsts.remoteServiceBaseUrl + '/Purchase/PurchaseInvoice/' + id, '_blank');
        }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createStockTransfer(): void {
        this._router.navigate(['/app/stock/stocktransfer/createOrEdit']);
    }

    deleteStockTransfer(stockTransfer: StockTransferDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._stockTransferServiceProxy.deleteStockTransfer(stockTransfer.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }
   


    exportToExcel($event): void {
        //this._stockTransferServiceProxy
        //    .getAddStocksToExcel(
        //        this.filterText,
        //        $event,
        //        this.vendorDisplayPropertyFilter,
        //        undefined
        //    )
        //    .subscribe((result) => {
        //        this._fileDownloadService.downloadTempFile(result);
        //    });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportpurchaseInvoicesProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportpurchaseInvoicesUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportpurchaseInvoicesUploadFailed'));
    }

    resetFilters(): void {
        this.filterText = '';
        this.vendorDisplayPropertyFilter = '';
        

        this.getStockTransfer();
    }

    showExcelColumnSelectionModal() {
        //this._stockTransferServiceProxy.getAddStockExcelColumnsToExcel().subscribe((result) => {
        //    this.excelColumnSelectionModal.show(result);
        //});
    }


}
